import axios from 'axios'
import constants from '@/helpers/constants'

const BONUSES_LOCALE_STORAGE_KEY = 'bonusesInfo'

export default {
  state: {
    bonusesInfo: null,
    bonusesInfoCart: {},
    bonusesInfoFromLocalStorage: localStorage.getItem(BONUSES_LOCALE_STORAGE_KEY) ? JSON.parse(localStorage.getItem(BONUSES_LOCALE_STORAGE_KEY)) : null,
    currentBonusValue: 0,
    isLoading: false
  },
  getters: {
    isChangedBonuses: (state) => {
      return !!((state.bonusesInfoFromLocalStorage && ('total_bonuses' in state.bonusesInfoFromLocalStorage)) &&
        (state.bonusesInfo && ('total_bonuses' in state.bonusesInfo)) &&
        state.bonusesInfoFromLocalStorage.total_bonuses !== state.bonusesInfo.total_bonuses)
    },
    totalBonusesInCurrency: (state) => {
      if ((state.bonusesInfoFromLocalStorage && ('total_bonuses' in state.bonusesInfoFromLocalStorage)) && !state.bonusesInfo) return state.bonusesInfoFromLocalStorage['total_bonuses']
      if (state.bonusesInfo && ('total_bonuses' in state.bonusesInfo)) return state.bonusesInfo['total_bonuses']

      return null
    },
    currentBonuses: (state) => {
      return state.currentBonusValue
    }
  },
  mutations: {
    SET_BONUSES_INFO: (state, data) => {
      state.bonusesInfo = data
    },
    SET_BONUSES_INFO_CART: (state, data) => {
      state.bonusesInfoCart = data
    },
    SET_CURRENT_BONUS_VALUE: (state, data) => {
      state.currentBonusValue = data
    },
    SET_IS_LOADING_BONUSES: (state, bool) => {
      state.isLoading = bool
    }
  },
  actions: {
    FETCH_BONUSES_INFO: async ({ commit, rootGetters, dispatch }) => {
      commit('SET_IS_LOADING_BONUSES', true)

      await axios
        .get(rootGetters.urlLanguagePrefix + '/cabinet/default/bonuses-info/')
        .then(res => {
          if (res?.data?.data) {
            commit('SET_BONUSES_INFO', res.data.data)
            dispatch('SET_BONUSES_INFO_TO_LOCAL_STORAGE', res.data.data)
          }
        })
        .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('server_error')))
        .finally(() => commit('SET_IS_LOADING_BONUSES', false))
    },
    FETCH_CART_BONUSES_INFO: (ctx, params) => {
      if (!ctx.rootGetters.cartSort.products.length || !ctx.rootGetters.isAuth) return
      const isCheckout = constants.IS_CHECKOUT()
      const isManagerCheckout = ctx.rootState.checkout.isManagerPage
      const innerParams = params || {}
      const { client_phone: clientPhone } = innerParams
      const data = []

      if (clientPhone) {
        data.push('client_phone=' + clientPhone)
      }

      if (isCheckout || isManagerCheckout) {
        ctx.dispatch('SET_LOADING_COMPONENT', { bonusesInModal: true }, { root: true })

        const storeUid = isCheckout ? ctx.rootState.deliveryNew?.formData?.selectedSpot?.uid : ctx.rootState.checkout.formData.deliveryInfo?.deliverySpot?.uid
        const deliveryMethodId = isCheckout ? ctx.rootState.deliveryNew?.formData?.deliveryMethod?.method_id : ctx.rootState.checkout.formData.deliveryType?.methodId

        if (storeUid) {
          data.push('store_uid=' + storeUid)
        }

        if (deliveryMethodId) {
          data.push('delivery_method_id=' + deliveryMethodId)
        }
      }

      const dataString = (data.length > 0) ? '?' + data.join('&') : ''

      return new Promise(resolve => {
        axios
          .get(ctx.rootGetters.urlLanguagePrefix + '/shop/cart/get-user-bonuses-info/' + dataString)
          .then(response => {
            if (response?.data) {
              ctx.commit('SET_BONUSES_INFO', response.data)
              ctx.dispatch('SET_BONUSES_INFO_TO_LOCAL_STORAGE', response.data)
            }
          })
          .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('server_error')))
          .finally(() => {
            if (isCheckout) {
              ctx.dispatch('SET_LOADING_COMPONENT', { bonusesInModal: false }, { root: true })
            }
            resolve()
          })
      })
    },
    SET_CURRENT_BONUS_VALUE_ACTION: (ctx, value) => {
      ctx.commit('SET_CURRENT_BONUS_VALUE', value)
    },
    SET_BONUSES_INFO_TO_LOCAL_STORAGE: (ctx, value) => {
      localStorage.setItem(BONUSES_LOCALE_STORAGE_KEY, JSON.stringify(value))
      // localStorage.setItem(BONUSES_LOCALE_STORAGE_KEY, JSON.stringify({ ...value, total_bonuses: Math.round(new Date().getTime()) }))
    },
    REMOVE_BONUSES_INFO_FROM_LOCAL_STORAGE: () => {
      localStorage.removeItem(BONUSES_LOCALE_STORAGE_KEY)
    }
  }
}
